import {Column, Entity} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {AchievementInterface} from "@/modules/archiements/interfaces";
import {IconEnum} from "@/modules/vue/enums";
import {AchievementTypeEnum} from "../enums";
import {AchievementRewardsType} from "@/modules/archiements/types";

@Entity()
export class Achievement extends BaseEntity implements AchievementInterface {
  @Column({type: 'varchar', enum: AchievementTypeEnum})
  type: AchievementTypeEnum;

  @Column({type: 'integer'})
  neededValue: number;

  @Column({type: 'integer'})
  currentValue: number = 0;

  @Column({type: 'boolean'})
  rewarded = false;

  @Column({type: 'boolean'})
  achieved = false;

  @Column({type: 'simple-json'})
  rewards: AchievementRewardsType;
  //
  // @Column({type: 'varchar', length: 50})
  // rewardsRaw: string;
  //
  // set rewards(rewards: AchievementRewardsType) {
  //   this.rewardsRaw = JSON.stringify(rewards);
  // }
  //
  // get rewards() {
  //   return JSON.parse(this.rewardsRaw);
  // }

  get isMoney() {
    return [AchievementTypeEnum.PLAYER_BUY, AchievementTypeEnum.PLAYER_SELL].includes(this.type);
  }

  get icon() {
    return IconEnum.CheckRound;
  }
}
